import React from 'react';
import { Layout } from 'antd';

export default () => (
  <Layout>
    <Layout.Content>Sorry, page not found!</Layout.Content>
  </Layout>
);
